import React from 'react'
import { FormTextField } from '@fs/zion-form'
import { useTranslation } from 'react-i18next'

export const NAME = 'city'

export const CityField = ({ disabled }) => {
  const [t] = useTranslation()
  return (
    <FormTextField
      name={NAME}
      label={`${t('form.field.city.label', 'City')} *`}
      disabled={disabled}
      required
      autoComplete="address-level2"
    />
  )
}
